import { render, staticRenderFns } from "./ContractFicheHorse.vue?vue&type=template&id=e32d90c8&"
import script from "./ContractFicheHorse.vue?vue&type=script&lang=js&"
export * from "./ContractFicheHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports